import React, { useEffect, useState, useCallback } from 'react';
import ReactApexChart from 'react-apexcharts';
import { formatToKOrM } from '../../../../helper';

const HorizontalBarChart = ({ item, showByPercentage }) => {
    const [series, setSeries] = useState([]);

    useEffect(() => {
        // Create a flat array for the series data
        if (item.hasOwnProperty("1_Division")) {
            const formattedData = [
                {
                    name: item["1_Division"] || "NA",
                    data: [item[showByPercentage ? "1_Pallets_Percentage" : "1_Pallets"] || 0],  // Ensure data is not null or undefined
                    color: "#FFC501",
                },
                {
                    name: item["2_Division"] || "NA",
                    data: [item[showByPercentage ? "2_Pallets_Percentage " : "2_Pallets"] || 0],  // Ensure data is not null or undefined
                    color: "#FC6135",
                },
                {
                    name: item["3_Division"] || "NA",
                    data: [item[showByPercentage ? "3_Pallets_Percentage" : "3_Pallets"] || 0],  // Ensure data is not null or undefined
                    color: "#CF0038",
                },
                {
                    name: item["4_Division"] || "NA",
                    data: [item[showByPercentage ? "4_Pallets_Percentage" : "4_Pallets"] || 0],  // Ensure data is not null or undefined
                    color: "#AC4EC6",

                }
            ];

            setSeries([...formattedData]);
        }

    }, [item, showByPercentage]);


    const initialOptions = {
        chart: {
            type: 'bar',
            height: 100,
            stacked: true,
            stackType: '100%',
            toolbar: { show: false },
            offsetX: 0,
            offsetY: 0,
        },
        plotOptions: {
            bar: {
                horizontal: true,
                columnWidth: "2%",
                barHeight: '50%',
                borderRadius: 5, // Adjust this value to control the rounding
                borderRadiusApplication: 'end', // Apply rounding only to the tips
            },
        },
        stroke: { width: 4, colors: ['#fff'] },
        xaxis: {
            categories: [],
            labels: { show: false },
            axisBorder: { show: false },
            axisTicks: { show: false },
            lines: { show: false },
            padding: { left: 0, right: 0 },
        },
        yaxis: { title: { text: null }, show: false, padding: { top: 0, bottom: 0 } },
        grid: { show: false, padding: { left: 0, right: 0, top: 0, bottom: 0 } },
        tooltip: {
            y: { formatter: val => showByPercentage ? Number(val).toFixed(2) + "%" : formatToKOrM(Number(val)) }, // Format the value in tooltip as well
        },
        fill: { opacity: 1 },
        legend: {
            position: 'bottom',
            horizontalAlign: 'left',
            offsetX: -20,
            offsetY: -25,
            fontSize: "10px",
            markers: {
                width: 6,
                height: 6,
                shape: "round",
            },
        },
        dataLabels: {
            enabled: true, // Enable data labels on bars
            formatter: function (val) {
                if (showByPercentage) {
                    return (Number(val).toFixed(2) + "%");
                } else {
                    return formatToKOrM(Number(val))+"%";
                }
            },
        },
    };

    return (
        <div style={{ width: '100%', height: '100px', overflow: 'hidden', marginTop: "-40px" }}>
            <div id="chart" style={{ margin: 0, padding: 0 }}>
                {series?.length > 0 &&
                    <ReactApexChart options={initialOptions} series={series} type="bar" height={"120px"} />
                }
            </div>
        </div>
    );
};

export default HorizontalBarChart;
